import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  pageWrap: {
    borderRadius: 8,
    paddingBottom: 20,
    boxShadow:
      "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    margin: "12px 0 80px",
  },
  paperWrap: {
    backgroundColor: "#F0F1FF",
    // marginTop: 12,
    // marginBottom: 40,
  },
  pageTitle: {
    paddingTop: 15,
    marginLeft: 20,
  },
  tabWrap: {
    borderBottom: "solid 1px " + theme.palette.textColor.gray2,
  },
  content: {
    padding: theme.spacing(2),
  },
  fab: {
    marginLeft: theme.spacing(2),
  },
  fab1: {
    display: "flex",
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(6),
  },
  wrapIcon: {
    // marginTop: 20,
    width: "25vh",
    // display: "inline-block",
  },
  text: {
    color: "#fff",
    // marginTop: 12,
    // width: "30vh",
  },
  header: {
    height: 75,
    // width: 960,
    maxWidth: "100%",
    backgroundColor: theme.palette.primary.main + " !important",
    paddingLeft: "20px",
    paddingRight: "20px",
    marginBottom: "25px",
    // position: "fixed",
    // zIndex: 999,
    top: 0,
  },
  wrapHeader: {
    display: "flex",
    // padding: "0",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
}));

export default useStyles;
